import React from "react";

import { ArrowRight as ArrowRightIcon } from "react-feather";
import {
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  makeStyles,
} from "@material-ui/core";
import { format, isToday } from "date-fns";
import { head } from "lodash";
import pluralize from "pluralize";

import { CalendarSummaryProps, LessonSummary } from "./types";
import { Link } from "react-router-dom";
import { NoFutureLessons, TodaysLessons } from "./components";
import CardSkeleton from "./components/Skeleton";

const useStyles = makeStyles(theme => ({
  header: {
    justifyContent: "space-between",
    display: "flex",
  },
  subHeader: {
    fontSize: "0.75rem",
    color: theme.palette.text.primary,
  },
  button: {
    color: theme.palette.secondary.main,
  },
  footer: {
    display: "flex",
    flex: 1,
    justifyContent: "flex-end",
    margin: theme.spacing(2),
  },
}));

const renderLessons = (lessons: Array<LessonSummary> = []) => {
  const firstLesson = head(lessons);

  if (!firstLesson) {
    return <NoFutureLessons />;
  }

  return <TodaysLessons lessons={lessons} />;
};

const CalendarSummary: React.FC<CalendarSummaryProps> = ({
  lessons,
  loading = false,
  handleViewCalendar = () => {},
}) => {
  const classes = useStyles();

  if (loading) {
    return <CardSkeleton />;
  }

  return (
    <Card>
      <CardHeader
        title={
          lessons &&
          pluralize(
            "lesson",
            lessons.filter(lesson => isToday(new Date(lesson.startDateTime)))
              .length,
            true,
          )
        }
        subheader={format(new Date(Date.now()), "do MMMM yyyy")}
        classes={{ content: classes.header }}
        titleTypographyProps={{ component: "h3", variant: "h3" }}
        subheaderTypographyProps={{
          className: classes.subHeader,
          ["data-test"]: "calendar-summary-date-today",
        }}
      />
      <Divider />

      {renderLessons(lessons)}

      <Box className={classes.footer}>
        <Button
          endIcon={<ArrowRightIcon width={20} />}
          to="/calendar"
          component={Link}
          onClick={handleViewCalendar}
          className={classes.button}
        >
          View Calendar
        </Button>
      </Box>
    </Card>
  );
};

export default CalendarSummary;
